import React, { useState, useEffect } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
// import AddCategory from "./AddCategory";
// eslint-disable-next-line
import AddCategory from "./addservices";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import {
    ToastError,
    ToastSuccess,
} from "../../../Components/utils/ToastMessage";
import swal from "sweetalert";
function Warehouse() {
    const Navigate = useNavigate();

    const [params, setparams] = useSearchParams();
    const [tableLoad, setTableLoad] = useState(false);
    const [pageCount, setpageCount] = useState(1);
    const [category, setCategory] = useState(false);

    const [editable, setEditable] = useState(false);
    const [allItems, setAllItems] = useState([]);
    const [categoryItems, setCategoryItems] = useState([]);
    const [categorysearchItems, setCategorySearchItems] = useState([]);

    let [loading, setLoading] = useState(true);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const categoryHandler = () => {
        setCategory((prev) => !prev);
    };
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;
    const getcategories = () => {
        Services.OmniBanners("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    let banners = [];
                    setAllItems(res?.banners);
                    if (res.banners.length > 0) {
                        for (let i = 0; i < res.banners.length; i++) {
                            let item = {
                                bannerId: res.banners[i].bannerId,
                                bannertype: res.banners[i].bannertype,
                            };
                            if (res.banners[i].images.length > 0) {
                                for (
                                    let j = 0;
                                    j < res.banners[i].images.length;
                                    j++
                                ) {
                                    item = {
                                        ...item,
                                        uid: uuidv4(),
                                        categoryid:
                                            res.banners[i].images[j].categoryid,
                                        categoryname:
                                            res.banners[i].images[j]
                                                .categoryname,
                                        fileName:
                                            res.banners[i].images[j].fileName,
                                        location:
                                            res.banners[i].images[j].location,
                                        subcategoryid:
                                            res.banners[i].images[j]
                                                .subcategoryid,
                                        subcategoryname:
                                            res.banners[i].images[j]
                                                .subcategoryname,
                                        id: res.banners[i].images[j].id,
                                        type: res.banners[i].images[j].type,
                                        img_obj_id:
                                            res.banners[i].images[j].img_obj_id,
                                    };
                                    banners.push(item);
                                }
                                setCategoryItems(banners);
                                setCategorySearchItems(banners);
                            }
                            /* else {
                                item = { ...item, images: [] };
                                banners.push(item);
                            } */
                        }
                    } else {
                        setCategoryItems(res.banners);
                        setCategorySearchItems(res.banners);
                    }
                    setTableLoad(false);
                    setLoading(false);
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
                setTableLoad(false);
            });
    };
    useEffect(() => {
        getcategories();
        if (params.get("page")) {
            setpageCount(Number(params.get("page")));
        }

        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        let timer = setTimeout(() => {
            setTableLoad(false);
            // console.log("11");
        }, 150);
        return () => {
            clearTimeout(timer);
        };
    }, [categorysearchItems]);
    // console.log(categoryItems);
    const deleteHandler = (e) => {
        let bannertype = e.currentTarget.getAttribute("bannertype");
        let img_obj_id = e.currentTarget.getAttribute("id");
        swal("Are You sure you want to Delete?", {
            icon: "warning",
            className: dashboardclasses["logout-popup"],
            dangerMode: true,
            buttons: {
                cancel: "Cancel",
                catch: {
                    text: "Delete",
                    value: "Delete",
                    className: dashboardclasses[".cancel-delete"],
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Delete":
                    Services.deletebanners(
                        "POST",
                        JSON.stringify({ bannertype, img_obj_id }),
                        token
                    )
                        .then((res) => {
                            if (res.Status === 1) {
                                setTableLoad(true);
                                getcategories();
                                toast.success(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            } else if (res.Status === 0) {
                                toast.error(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                if (res.Message === "Token expired") {
                                    Navigate("/");
                                }
                            }
                        })
                        .catch((err) => {
                            // alert(err);
                            alert("something went wrong please try again");
                            console.log(err);
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };

    const statusFormatter = (cell) => {
        let classname =
            cell === "Active"
                ? dashboardclasses["status_active"]
                : dashboardclasses["status_inactive"];
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                <p className={classname}>{cell}</p>
            </div>
        );
    };
    const ActionFormatter = (cell, cellcontent) => {
        return (
            <div className={dashboardclasses.tablebtns}>
                <button
                    onClick={() => {
                        setEditable(cellcontent);
                        setCategory(true);
                    }}>
                    <FaRegEdit size={18} />
                </button>
                <button
                    onClick={deleteHandler}
                    id={cellcontent.img_obj_id}
                    bannertype={cellcontent.bannertype}>
                    <MdDelete size={18} />
                </button>
            </div>
        );
    };
    const ImageFormatter = (cell, cellContent) => {
        console.log(cell, cellContent);
        return (
            <div className={dashboardclasses["banner-wrapper"]}>
                <a target="_blank" href={cell}>
                    <img src={cell} alt="" width={"80px"} />
                </a>
            </div>
        );
    };
    const columns = [
        {
            dataField: "bannertype",
            text: "BANNER TYPE",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "type",
            text: "TYPE",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "categoryname",
            text: "CATEGORY",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        // {
        //     dataField: "subcategoryname",
        //     text: "SUBCATEGORY",
        //     sort: false,
        //     headerStyle: (colum, colIndex) => {
        //         return { ...headerstyles };
        //     },
        // },

        {
            dataField: "location",
            text: "BANNER IMAGE",
            sort: false,
            formatter: ImageFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        // {
        //     dataField: "status",
        //     text: "STATUS",
        //     sort: false,
        //     formatter: statusFormatter,
        //     headerStyle: (colum, colIndex) => {
        //         return { ...headerstyles };
        //     },
        // },

        {
            dataField: "ACTIONS",
            text: "ACTIONS",
            sort: false,
            formatter: ActionFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "100px" };
            },
        },
    ];
    const pagination = paginationFactory({
        page: pageCount,
        sizePerPage: 8,
        lastPageText: ">>",
        firstPageText: "<<",
        nextPageText: ">",
        prePageText: "<",
        hideSizePerPage: true,
        showTotal: true,
        alwaysShowAllBtns: true,
        onPageChange: function (page, sizePerPage) {
            window.scrollTo({ top: 10, behavior: "instant" });
            setparams({ page: page });
        },
        onSizePerPageChange: function (page, sizePerPage) {
            console.log("page", page);
            console.log("sizePerPage", sizePerPage);
        },
    });
    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const searchHandler = (e) => {
        setTableLoad(true);
        setparams({ page: 1 });
        setpageCount(1);
        const search = categoryItems.filter((item) =>
            item.bannertype.toLowerCase().includes(e.target.value.toLowerCase())
        );
        // console.log(search);
        setCategorySearchItems(search);
    };
    return (
        <>
            {category && (
                <AddCategory
                    setmodal={setCategory}
                    editable={editable}
                    setEditable={setEditable}
                    getCategories={getcategories}
                    setpageCount={setpageCount}
                    tableload={setTableLoad}
                    categoryItems={allItems.map((item) => item.bannertype)}
                />
            )}

            <Layout Active={"Omnimart"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        <h3>Omnimart Banners</h3>

                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                <div
                                    className={
                                        dashboardclasses["category-form-two"]
                                    }>
                                    <input
                                        type={"text"}
                                        placeholder="search by Banner type"
                                        onChange={searchHandler}
                                    />

                                    <button onClick={categoryHandler}>
                                        + Add Banner
                                    </button>
                                </div>
                                {tableLoad ? (
                                    <div className={dashboardclasses["loader"]}>
                                        <ScaleLoader
                                            color={"black"}
                                            loading={true}
                                            css={override}
                                            size={150}
                                        />
                                    </div>
                                ) : (
                                    <div className="category-table">
                                        <BootstrapTable
                                            bootstrap4
                                            keyField="uid"
                                            data={categorysearchItems}
                                            columns={columns}
                                            defaultSorted={defaultSorted}
                                            pagination={pagination}
                                            wrapperClasses="table-responsive"
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Warehouse;
